import React from 'react'

const LangContext = React.createContext({
  langPrefix: '', // .ie: /fr
})

export default LangContext
